module.exports = __webpack_public_path__ + "static/media/bnb.db3c2a1d.svg";